export const parseReportParams = search => {
  const params = new URLSearchParams(search);
  const projectId = params.get('project');
  const year = params.get('year');
  const month = params.get('month');

  return {
    projectId: projectId ? Number(projectId) : null,
    year: year ? Number(year) : null,
    month: month ? Number(month) : null
  };
};

export const buildReportSearch = ({ projectId, year, month }) => {
  const params = new URLSearchParams();

  if (projectId) {
    params.set('project', projectId);
  }
  if (year) {
    params.set('year', year);
  }
  if (month) {
    params.set('month', month);
  }

  const query = params.toString();
  return query ? `?${query}` : '';
};

export const isValidMonth = month => Number.isInteger(month) && month >= 1 && month <= 12;

export const isValidYear = (year, yearOptions) =>
  Number.isInteger(year) && yearOptions.some(option => option.value === year);
